<div class="zint-base-card mt-3">
  <h4 class="mb-3">Configuration Overview</h4>
    <div class="d-flex flex-column flex-gap-1">
    @for (step of statusSummaryData.overviewData; track $index) {
      <div class="row no-gutters mappings-row">
        <span class="col-5 col-md-5">
          <i class="mr-1" [ngClass]="renderCRMObjectIcons(step.stepType)"></i>
          {{step.stepTypeDisplay}}
        </span>
        <div class="col-5 col-md-5">
        @if (step.stepType === 'company_matcher') {
          @if (step.overviewState?.status) {
            <div class="d-flex flex-column">
              <span class="text-bold-600 mb-1">{{step.overviewState.status}}</span>
              @if (step.overviewState.status === 'Completed' && step.overviewState.totalRows) {
                <span class="text-small text-grey-600">
                  Updated {{step.overviewState.rowsProcessed || 0}} CRM records;
                  {{step.overviewState.totalRows - (step.overviewState.rowsProcessed || 0)}} unmatched.
                  <a href="/matcher/crm" target="_blank" class="text-vivid-blue">Click here</a> to manually validate.
                </span>
              }
            </div>
          } @else {
            <span class="text-bold-600">Loading...</span>
          }
        } @else if (step.overviewState === true || step.overviewState === false) {
          <span class="status-badge-base " [ngClass]="step.overviewState ? 'status-badge-green':'status-badge-orange'">{{step.overviewState ? 'Enabled': 'Not Configured'}}</span>
        }@else {
          <span class="text-bold-600">{{step.overviewState || 'pending'}}</span>
        }
        </div>
        <div class="col-2">
          <button class="rounded-btn-base rounded-btn-light" matTooltip="View or Edit Configuration">
            <i class="fal fa-edit" role="button" (click)="editStep(step.stepType)"></i>
          </button>
        </div>
      </div>  
    }
    </div>
</div>

<div class="zint-base-card mt-3">
  <h4 class="mb-3">Mappings & Permissions</h4>
  <div class="d-flex flex-column flex-gap-1">
    @for (item of statusSummaryData.mappingsData; track $index) {
    <div class="row no-gutters align-items-baseline mappings-row">
      <span class="col-5">
        <i class="mr-1" [ngClass]="renderCRMObjectIcons(item.stepType)"></i>
        {{item.stepTypeDisplay}}
      </span>
      <span class="col-5">{{renderMappingDetails(item.stepType, item.overviewDetails)}}
        @if (item.showNoConfigWarning) {          
          <sup matTooltip="Import not enabled!"><i class="fas fa-triangle-exclamation highlighted"></i></sup>
        }
      </span>
      <div class="col-2">        
        <button class="rounded-btn-base rounded-btn-light" matTooltip="View or Edit Configuration">
          <i class="fal fa-edit" role="button" (click)="editStep(item.stepType)"></i>
        </button>
      </div>
    </div>
    }
  </div>
</div>

@if (enrichmentEnabled) {
  <div class="zint-base-card mt-3">
    <h4 class="mb-3">Enrichment Summary</h4>
    <div class="d-flex flex-column flex-gap-1">
      <div class="row no-gutters">
        <span class="col-12 col-md-12">
          Enrichment Cycle: {{statusSummaryData.enrichmentSummaryData?.startDate | date: 'd MMM y'}} to {{statusSummaryData.enrichmentSummaryData?.endDate | date: 'd MMM y'}}
        </span>
      </div>
    </div>
    <div class="d-flex flex-column flex-gap-1">
      <div class="row no-gutters">
        <span class="col-12 col-md-12">
          You've used {{statusSummaryData.enrichmentSummaryData?.quotaUsage }} out of {{statusSummaryData.enrichmentSummaryData?.quotaAmount }} records this cycle.
        </span>
      </div>
    </div>
  </div>
}

<div class="zint-base-card mt-3">
  <h4 class="mb-3">Log History</h4>
  <div class="row no-gutters align-items-baseline mappings-row mb-2">
    <span class="col-3 text-bold-600"></span>
    <span class="col-3 text-bold-600">Type</span>
    <span class="col-3 text-bold-600">Records Processed</span>
    <span class="col-3 text-bold-600">Errors</span>
  </div>
  @for (item of statusSummaryData.logHistory; track item.id) {
    <div class="row no-gutters align-items-baseline mappings-row mb-2">
      <span class="col-3">
        <i class="far fa-clock-rotate-left fa-flip-horizontal"></i>
        {{item.lastUpdated | date: 'medium'}}
      </span>
      <span class="col-3">
        <span>{{logTypeLabel(item.logType)}}</span>
      </span>
      <span class="col-3">
        <span>{{item.numberOfRecords}}&nbsp;{{item.numberOfRecords | i18nPlural: pluralMappings.record}}</span>
      </span>
      <div class="col-3 max-height-15vh">
        @if (item.errorSummary?.length) {
          <truncate-text [inputText]="inlineErrorSummary(item)" limit="16"></truncate-text>
        }
        @else {
          <span>None</span>
        }
      </div>
    </div>
  }

  @if (hasMoreLogsThanShown) {
    <button class="rounded-btn-base rounded-btn-light-outline btn-p-md mt-2" (click)="openLogHistoryModal()">
      <i class="far fa-list-timeline mr-2"></i>
      View all {{logHistoryCount}} logs
    </button>
  }
</div>

@if (showLogHistoryModal) {
  <zint-modal [modalConfig]="logHistoryModalConfig">
    <div modalContent>
      <div class="row no-gutters align-items-baseline mappings-row mb-2">
        <span class="col-2 text-bold-600">Date</span>
        <span class="col-2 text-bold-600">Type</span>
        <span class="col-2 text-bold-600">Records Processed</span>
        <span class="col-6 text-bold-600">Errors</span>
      </div>

      @if (isLoadingModalLogs) {
        <div class="my-3">
          <i class="fas fa-spinner fa-spin mr-2"></i>
          Loading logs...
        </div>
      } @else if (!modalLogs.length) {
        <div class="my-3">No logs to show.</div>
      } @else {
        @for (log of modalLogs; track log.id) {
          <div class="row no-gutters mappings-row mb-3">
            <span class="col-2">{{log.lastUpdated | date: 'medium'}}</span>
            <span class="col-2">{{logTypeLabel(log.logType)}}</span>
            <span class="col-2">{{log.numberOfRecords}}&nbsp;{{log.numberOfRecords | i18nPlural: pluralMappings.record}}</span>
            <div class="col-6">
              @if (log.errorSummary?.length) {
                @for (group of log.errorSummary; track $index) {
                  <div class="mb-2">
                    @if (group.recordsAffected !== null) {
                      <span class="text-bold-600">
                        {{group.recordsAffected}}&nbsp;{{group.recordsAffected | i18nPlural: pluralMappings.record}}:
                      </span>
                    }
                    <span>{{errorMessage(group.message)}}</span>
                    @for (sample of group.samples; track $index) {
                      <div class="small text-muted mt-1">e.g. {{sample}}</div>
                    }
                  </div>
                }
              } @else {
                <span>None</span>
              }
            </div>
          </div>
        }
      }

      @if (modalTotalPages > 1) {
        <div class="d-flex align-items-center justify-content-end mt-2">
          <button class="rounded-btn-base rounded-btn-light-outline btn-p-sm mr-2"
                  [disabled]="!modalHasPrevious || isLoadingModalLogs"
                  (click)="loadLogHistoryPage(modalPage - 1)">
            <i class="far fa-chevron-left"></i>
          </button>
          <span class="mx-2">Page {{modalPage}} of {{modalTotalPages}}</span>
          <button class="rounded-btn-base rounded-btn-light-outline btn-p-sm ml-2"
                  [disabled]="!modalHasNext || isLoadingModalLogs"
                  (click)="loadLogHistoryPage(modalPage + 1)">
            <i class="far fa-chevron-right"></i>
          </button>
        </div>
      }
    </div>
  </zint-modal>
}
